module.exports = __webpack_public_path__ + "images/ezaem-e37fec8d.png";